<!-- 求职管理 -->
<template>
  <div class="job">
    <!-- 导航栏 -->
    <van-nav-bar fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 标题 -->
    <div class="job-container">
      <div class="job-top">
        <span>管理求职意向</span>
        <div class="count">
          <span>{{list.length}}</span>
          <span>/3</span>
        </div>
      </div>
      <div class="job-bottom">我们会根据你的“求职意向”在首页展示合适的职位</div>
    </div>
    <!-- 列表项 -->
    <div class="job-list" @click="show=true">
      <span class="list-left">求职状态</span>
      <div class="list-right">
        {{status}}
        <img src="@/assets/img/position/into.png" class="back" />
      </div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="bullet">
        <div
          class="bullet-item"
          v-for="(item, index) in items"
          :key="index"
          @click="tapStatus(item)"
        >{{item.name}}</div>
        <div class="canle" @click="show=false">取消</div>
      </div>
    </van-popup>
    <div
      class="list-item"
      v-for="(item, index) in list"
      :key="index"
      @click="addPosition(0,item.resume_intent_id)"
    >
      <div class="item-left">
        <span>{{item.job_cn}} {{item.wage_cn}}</span>
        <img src="@/assets/img/user/edit.png" class="back" />
      </div>
      <p class="item-right">{{item.district_cn}}</p>
    </div>
    <!-- 按钮 -->
    <div class="request-btn" @click="addPosition(1)">
      <button class="btns">添加求职意向</button>
    </div>
  </div>
</template>

<script>
import {
  queryPositionList,
  getKindArray,
  editPositionStatus,
  queryPreson,
  getResumeApplyStatus
} from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: {},
  inject: ["Token"],
  data() {
    return {
      status: "请选择就业情况", //待业状态
      items: ["随时到岗", "暂不考虑", "考虑机会"],
      show: false, //求职状态
      list: [] //求职列表
    };
  },
  computed: {},
  methods: {
    //   返回上级
    goBack() {
      this.$router.back();
    },
    // 选择待业状态
    tapStatus(val) {
      // //(val);
      var that = this;
      that.status = val.name;
      editPositionStatus({ status: val.value });
      // switch (val) {
      //   case "随时到岗":
      //     editPositionStatus({ status: 1 }).then(res => {});
      //     break;
      //   case "暂不考虑":
      //     that.statusNum = 2;
      //     editPositionStatus({ status: 2 });
      //     break;
      //   case "考虑机会":
      //     editPositionStatus({ status: 3 });
      //     break;
      // }
      that.show = false;
    },

    //
    //选择求职意向
    addPosition(val, id) {
      var that = this;
      if (val == 0) {
        // 编辑求职意向
        that.$router.push({
          name: "Experience",
          params: {
            title: 3,
            id: id
          }
        });
      } else {
        // 添加求职意向
        that.$router.push({
          name: "Experience",
          params: {
            title: 4
          }
        });
      }
    },
    // 获取求职列表
    getResumentList() {
      var that = this;
      queryPositionList().then(res => {
        // //(res);
        if (res.code == 1) {
          that.list = res.data;
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 3000);
        }
      });
    }
    // 获取当前就业状态
    // getWorkStatus(){
    //   var that=this;
    //   getKindArray({
    //     key:'current'
    //   }).then(res=>{
    //     //(res);
    //     if(res.code==1){
    //       that.items=res.data
    //     }
    //   })
    // }
  },
  created() {},
  mounted() {
    var that = this;
    that.Token();
    that.getResumentList(); //获取求职列表
    queryPreson().then(res => {
      //(res);
      that.status =
        res.data.apply_status.name == ""
          ? that.status
          : res.data.apply_status.name;
    });
    getResumeApplyStatus().then(res => {
      if (res.code == 1) {
        that.items = res.data;
      }
    });

    // that.getWorkStatus();//获取就业状态
  }
};
</script>
<style lang='less' scoped>
.job {
  padding: 0 0.32rem;
  // 标题
  .job-container {
    margin-top: 0.2rem;
    .job-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 0.48rem;
        font-weight: bold;
        line-height: 0.6rem;
        color: rgba(51, 51, 51, 1);
      }
      .count {
        display: flex;
        align-items: center;
        span {
          font-size: 0.32rem;
          font-weight: bold;
          line-height: 0.45rem;
          color: rgba(77, 77, 77, 1);
        }
        span:first-child {
          color: #ff4343;
        }
      }
    }
    .job-bottom {
      margin-top: 0.16rem;
      font-size: 0.26rem;

      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(51, 51, 51, 1);
    }
  }
  //列表项
  .job-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.32rem 0;
    border-bottom: 0.01rem solid #e5e5e5;
    margin-top: 0.2rem;
    .list-left {
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.45rem;
      color: rgba(51, 51, 51, 1);
    }
    .list-right {
      display: flex;
      align-items: center;
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(153, 153, 153, 1);
    }
  }
  .bullet {
    text-align: center;
    background: #f8f8f8;
    font-size: 0.32rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    .bullet-item {
      background: #fff;
      line-height: 0.45rem;
      padding: 0.28rem 0;
    }
    .canle {
      background: #fff;
      margin-top: 0.2rem;
      line-height: 0.45rem;
      padding: 0.28rem 0;
    }
  }
  .list-item {
    padding: 0.32rem 0;
    .item-left {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.3rem;
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(51, 51, 51, 1);
    }
    p {
      font-size: 0.28rem;
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(77, 77, 77, 1);
      padding-top: 0.14rem;
    }
  }
}
</style>